import React from 'react'
import { Box, Text, createStyles, getStylesRef } from '@mantine/core'
import Fade from 'react-reveal/Fade'

const useStyles = createStyles(theme => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    padding: theme.spacing.md,
    borderRadius: theme.radius.md,
    backgroundColor: 'rgba(255, 255, 255, 0.20)',
    border: `1px solid rgba(255, 255, 255, 0.25)`,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'default',
    backdropFilter: 'blur(5px)',
    maxWidth: 600,
    margin: '0 auto',
    minHeight: 60,
    boxSizing: 'border-box',

    '&:hover': {
      transform: 'translateY(-4px)',
      borderRadius: theme.radius.lg,
      borderColor: 'rgba(255, 255, 255, 0.4)',
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
      boxShadow: `0 8px 24px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)`,
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },

    [`&:hover .${getStylesRef('emoji')}`]: {
      transform: 'scale(1.2) rotate(10deg)',
      transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
    },

    [`&:hover .${getStylesRef('text')}`]: {
      transition: 'color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },
  },
  emoji: {
    ref: getStylesRef('emoji'),
    fontSize: 28,
    lineHeight: 1,
    flexShrink: 0,
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    display: 'inline-block',
  },
  text: {
    ref: getStylesRef('text'),
    color: theme.colors.gray[0],
    fontSize: theme.fontSizes.md,
    fontWeight: 600,
    lineHeight: 1.5,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
}))

export interface PhilosophyCardProps {
  emoji: string
  text: string
  delay?: number
}

export const PhilosophyCard: React.FC<PhilosophyCardProps> = ({ emoji, text, delay = 0 }) => {
  const { classes } = useStyles()

  return (
    <Fade bottom delay={delay}>
      <Box className={classes.card}>
        <Text className={classes.emoji}>{emoji}</Text>
        <Text className={classes.text}>{text}</Text>
      </Box>
    </Fade>
  )
}
